import { Link, useLocation } from "react-router-dom";
import { Home, BookOpen, ShoppingBag, Store, ShoppingCart } from "lucide-react";
import { useCart } from "../context/CartContext";

const TABS = [
  { to: "/", label: "Home", icon: Home, testid: "bottomnav-home" },
  { to: "/herbs", label: "Herbs", icon: BookOpen, testid: "bottomnav-herbs" },
  { to: "/store", label: "Herb Store", icon: Store, testid: "bottomnav-store" },
  { to: "/shop", label: "Infuso", icon: ShoppingBag, testid: "bottomnav-shop" },
  { to: "/cart", label: "Cart", icon: ShoppingCart, testid: "bottomnav-cart" },
];

export const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const { count } = useCart();
  if (pathname === "/questionnaire") return null;
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-t border-gray-200 pb-[env(safe-area-inset-bottom)]" data-testid="mobile-bottom-nav">
      <div className="grid grid-cols-5">
        {TABS.map(({ to, label, icon: Icon, testid }) => {
          const active = to === "/" ? pathname === "/" : pathname === to || pathname.startsWith(to + "/");
          return (
            <Link
              key={to}
              to={to}
              data-testid={testid}
              className={`relative flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${active ? "text-primary" : "text-gray-500"}`}
            >
              <Icon className={`w-5 h-5 ${active ? "stroke-[2.4]" : ""}`} />
              {label}
              {to === "/cart" && count > 0 && (
                <span className="absolute top-0.5 right-[22%] bg-primary text-white text-[9px] font-bold rounded-full min-w-[15px] h-[15px] px-0.5 flex items-center justify-center" data-testid="bottomnav-cart-count">
                  {count}
                </span>
              )}
              {active && <span className="absolute top-0 h-0.5 w-8 bg-primary rounded-full" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
